import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

/// Contexto de la pantalla en la que está trabajando el usuario. Sirve para que instrumentar una acción
/// sea una sola línea en el componente: el expediente y el submódulo los pone este servicio.
/// Es un simple almacén de estado, no registra nada por su cuenta.
@Injectable({
    providedIn: 'root'
})
export class AuditContextService {

    private caseId: string | null = null;
    private submodule: string | null = null;

    constructor(private router: Router) {
        //al empezar una navegación el contexto anterior deja de ser válido. Se limpia en NavigationStart
        //y no en NavigationEnd porque la pantalla de destino fija su contexto durante la activación de la
        //ruta, antes de NavigationEnd, y limpiarlo después lo borraría nada más ponerlo.
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                this.clear();
            }
        });
    }

    /// Fija el expediente en el que se está trabajando. Lo llama cases-detail al cargar.
    setCase(caseId: string | null) {
        this.caseId = caseId;
    }

    /// Fija el submódulo activo. Lo llama el acordeón del expediente al abrir una pestaña.
    setSubmodule(submodule: string | null) {
        this.submodule = submodule;
    }

    getCaseId(): string | null {
        return this.caseId;
    }

    getSubmodule(): string | null {
        return this.submodule;
    }

    clear() {
        this.caseId = null;
        this.submodule = null;
    }

}
